const permissionHandleUserActivo = "usuarios:writeActivo";

export { permissionHandleUserActivo };